import ItemSelectionPage from './item-selection-page.component';
import { connect } from 'react-redux';
import { State } from 'widgets/redeem/root/root.reducers';
import { IItemSelectionPageStateProps, IItemSelectionPageDispatchProps } from './item-selection-page.types';
import { Dispatch } from 'types/dispatch';
import { goToItemsDisplayPage, submitGameItem } from '../pyc-redeem.actions';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

const mapStateToProps = (state: State): IItemSelectionPageStateProps => ({
    contentGameItem: state.PYCRedeemReducer.contentGameItems.find(
        item => (item.actionIds || []).includes(state.PYCRedeemReducer.selectedGameItemId)
    )!,
    platformList: [ PLATFORM_TYPES.PC ]
});

const mapDispatchToProps = (dispatch: Dispatch): IItemSelectionPageDispatchProps => ({
    goToItemsDisplayPage: (): void => {
        dispatch(goToItemsDisplayPage());
    },
    submitGameItem: (): void => {
        dispatch(submitGameItem());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemSelectionPage);
